import React from 'react';
import SelectField from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { addField } from 'react-admin';
import find from 'lodash/find';




class OperandInput extends React.Component {

    render() {
        const { input, meta: { touched, error }, attributeId, attributes} = this.props;

        const attribute = find(attributes,(element) => {
            return attributeId === element.id
        })

        if (!attributes || !attribute){
            return <span>Loading...</span>
        } else if (attribute.fieldType === 'string'){
            return (
                <SelectField
                    errorText={touched && error}
                    {...input}
                >
                    <MenuItem value='='>=</MenuItem>
                    <MenuItem value='Contains'>Contains</MenuItem>
                </SelectField>
            )
        } else if (attribute.fieldType === 'number'){
            return (
                <SelectField
                    errorText={touched && error}
                    {...input}
                >
                    <MenuItem value='>'>&gt;</MenuItem>
                    <MenuItem value='='>=</MenuItem>
                    <MenuItem value='<'>&lt;</MenuItem>
                </SelectField>
            )
        } else {
            return (
                null
            );
        }
    }
}
export default addField(OperandInput); // decorate with redux-form's <Field>